import { render, staticRenderFns } from "./ServicePageLayout.vue?vue&type=template&id=3ed961cc&scoped=true&"
import script from "./ServicePageLayout.vue?vue&type=script&lang=js&"
export * from "./ServicePageLayout.vue?vue&type=script&lang=js&"
import style0 from "./ServicePageLayout.vue?vue&type=style&index=0&id=3ed961cc&prod&scoped=true&lang=css&"
import style1 from "./ServicePageLayout.vue?vue&type=style&index=1&id=3ed961cc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed961cc",
  null
  
)

export default component.exports